<template>
  <div class="introduction">
    <div class="ground"></div>
    <div><img src="./../assets/plane.svg" class="introduction-plane" width="120"></div>
    <h3><span>1</span><span>Choisissez votre profil :</span></h3>
    <br>
    <br>
    <div class="introduction-cont">
      <div class="introduction-cont-cell" @click="clickChoice" data-id="/enceinte">
        <div class="introduction-cont-cell-img"><img src="./../assets/femme_enceinte.png" class="introduction-img" width="154"></div>
        <div class="introduction-cont-cell-text"><span>Femme enceinte</span>
          <span class="introduction-triangle"></span>
        </div>
      </div>
      <div class="introduction-cont-cell" @click="clickChoice" data-id="/enfants">
        <div class="introduction-cont-cell-img"><img src="./../assets/homme_enfants.png" class="introduction-img" width="220"></div>
        <div class="introduction-cont-cell-text"><span>Adulte avec de jeunes enfants</span>
          <span class="introduction-triangle"></span>
        </div>
      </div>
      <div class="introduction-cont-cell" @click="clickChoice" data-id="/couple">
        <div class="introduction-cont-cell-img"><img src="./../assets/couple.png" class="introduction-img" width="240"></div>
        <div class="introduction-cont-cell-text"><span>Couple</span>
        <span class="introduction-triangle"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //import Config from './config';
  
export default {
  name: 'introduction',
  data () {
    return {
      //msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted: function() {
    document.querySelector(".buttonPrint").classList.add("hide");
    document.querySelector(".buttonChange").classList.add("hide");
    document.querySelector(".buttonRestart").classList.add("hide");
    document.querySelector(".popin").classList.add("hide");
    
    // ANIM INTRO

    const elements = this.$el.querySelectorAll(".introduction-cont-cell");    
    TweenLite.from(elements[0], 0.6, { x:800, ease:Quad.easeOut });
    TweenLite.from(elements[1], 0.6, { x:800, ease:Quad.easeOut, delay:0.3 });
    TweenLite.from(elements[2], 0.6, { x:800, ease:Quad.easeOut, delay:0.6 });
    
    TweenLite.to(document.querySelector(".introduction-plane"), 100, { left:1000, ease:Quad.easeOut });

    this.changeImgs(this.$el.querySelectorAll("img")); // PROD
  },
  methods: {
    clickChoice: function(event) {
      const div = event.target.closest(".introduction-cont-cell");
      this.$router.replace(div.getAttribute("data-id"));
      //this.$router.replace("/position");
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "../common.scss";  

  .introduction {
    //padding-top: 80px;
  }

  /*
  button {
    background-color: $red;
    border: 0;
    color: #fff;
    width: 30%;
    margin-top: 20px;
    cursor: pointer;
    transition: 0.5s background-color;
    &:hover {
      background-color: darken($red, 10%);
    }
  }

  img {
    margin-top: 30px;
  }
  */

  .introduction-cont {
    display: flex;
    margin: 0 auto;
    .introduction-cont-cell {
      width: 33.33%;
      height: 396px;
      color: $red;
      position: relative;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      img {
        transition: 0.5s -webkit-filter;
      }
      .introduction-cont-cell-text span:first-child {
        transition: 250ms all ease-out;
        display: inline-block;
      }
      &:hover {
        .introduction-cont-cell-text span:first-child {
          transform: translateY(-5px) scale(1.2);
          
        }
        img {
          -webkit-filter: brightness(110%); /* Safari */
          filter: brightness(110%);
        }
      }
      &:first-child {
        .introduction-cont-cell-img img {
          margin-top: 20px;
        }
      }
    }
    .introduction-cont-cell-img {
      display: flex;
      align-items: center;
      flex-grow: 1;
    }
    .introduction-cont-cell-text {
      width: 100%;
      height: 46px;
    }
  }
  
  .introduction-triangle {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 25px 25px 25px;
    border-color: transparent transparent #e2001a transparent;

    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 22px;
  }

  .introduction-plane {
    position: absolute;
    top: 100px;
    left: 0;
  }
  
</style>



// WEBPACK FOOTER //
// 0-Introduction.vue?618b46a6